/**
 * @owner @Appboy/whats-app
 */

export const kakaoConsumption = "/analytics_dashboard/:app_group_id/kakao_credit_consumption_detail_data";
